enum VariantCard {
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    ACTIVE = 'ACTIVE',
    REJECT = 'REJECT'
}

export { VariantCard }
